export const scriptsConfig = {
  echarts: {
    key: 'echarts',
    js: 'https://vfiles.gtimg.cn/wuji/echarts@5.1.2.min.js',
  },
  xlsx: {
    key: 'XLSX',
    js: 'https://vfiles.gtimg.cn/wuji/xlsx.full@0.11.19.min.js',
  },
  jstt: { // https://github.com/bcherny/json-schema-to-typescript
    key: 'jstt',
    js: 'https://vfiles.gtimg.cn/wuji/xystatic/json-schema-to-typescript.js',
  },
  vue3: {
    key: 'Vue3',
    js: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/starter/fb95891c.js',
  },
};
